module.exports = __webpack_public_path__ + "static/media/034.609cff3d.jpg";